import React, {Component} from "react";
import "./LocationModal.scss";
import '../styles/_layout.scss';
import {
    Button,
    CardBody,
    EditableList,
    Input,
    StandardListCell,
    Tabs
} from "gd-react";
import GridDuck from "gridduck";
import TariffForm from "../components/TariffForm";
import * as _ from 'underscore'
import GenericLoader from "../components/GenericLoader";
import GdModal from "../components/GdModal/GdModal";
import moment from "moment/moment";

class TariffModal extends Component {

    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.moveToTab = this.moveToTab.bind(this);
        this.saveSites = this.saveSites.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
        this.checkErrors = this.checkErrors.bind(this);
        this.deleteTariff = this.deleteTariff.bind(this);
        this.getAvailableList = this.getAvailableList.bind(this)
        this.getActiveList = this.getActiveList.bind(this)
        this.sitesChanged = this.sitesChanged.bind(this)
        this.errors = {};
        this.changed = false;
        this.tariffFormRef = React.createRef();
        let item = {};
        if (this.props.item) item = this.props.item;
        let _rates = item.rates;
        //FIXME Why is this happening (Really not the fix we want)
        if (item.rates && typeof item.rates === 'string') {
            _rates = JSON.parse(item.rates);
        }

        this.aperm_levels = ['edit', 'admin'];
        this.perm_levels = ['edit', 'admin'];
        if (this.props.item && this.props.item._permission === 'view') this.perm_levels.unshift('view');

        this.state = {
            update: 0,
            formUpdated: false,
            wide: false,
            newSitesList: [],
            existingSitesList: [],
            deleteConfirmation: '',
            name: item.name || '',
            currency: item.currency || 'GBP',
            utilityType: item.utilityType || this.props.utilityType || 'DELIVERED_SPEND',
            triedToSave: false,
            applyContractRange: item.applyContractRange || false,
            applyBillingCycle: item.applyBillingCycle || false,
            billingCycleType: item.billingCycleType || 'annually',
            billingCycleStartDay: item.billingCycleStartDay || 45,
            contractStart: item.contractStart || moment().add(1, 'months').startOf('month').unix(),
            contractEnd: item.contractEnd || moment().add(1, 'months').endOf('month').unix(),
            rates: _rates ? _.map(_rates, _.clone).map((r, i) => {
                r.id = Math.random();
                return {
                    startHour: r.start_hour || r.startHour || 0,
                    startMinute: r.start_minute || r.startMinute || 0,
                    endHour: r.end_hour || r.endHour || 0,
                    endMinute: r.end_minute || r.endMinute || 0,
                    rate: r.rate,
                    id: Math.random(),
                    index: i
                };
            }) : [{
                startHour: 0,
                startMinute: 0,
                endHour: 0,
                endMinute: 0,
                rate: 0,
                id: Math.random()
            }],
            standingCharge: item.standingCharge || 0
        }

        this.tabs = [[
            {
                id: 1,
                title: 'Details',
                onTabClick: this.onTabClick,
                selected: (this.props.openOnTab === 1 || !this.props.openOnTab)
            },
            {
                id: 2,
                title: 'Sites',
                onTabClick: this.onTabClick,
                disabled: !this.props.item,
                selected: (this.props.openOnTab === 2)
            }
        ]]

        if (this.props.item && this.props.item._permission !== 'view' && this.props.orgPerm !== 'view') {
            this.tabs[0].push({
                id: 3,
                title: 'Delete',
                onTabClick: this.onTabClick,
                selected: (this.props.openOnTab === 3)
            })
        }

        this.modalClosed = false;
    }

    componentDidMount() {

        let site_promises = [GridDuck.getSites({
            filters: [{field: '_permission', value: this.perm_levels}],
            items: 1,
            offset: 0
        })];

        if (this.props.item && this.props.item) {
            site_promises.push(GridDuck.getSites({
                filters: [{field: '_permission', value: this.perm_levels}, {
                    field: 'tariffIds',
                    value: [this.props.item ? this.props.item.id : null]
                }],
                items: 1,
                offset: 0
            }));
        }

        Promise.all(site_promises).then((res) => {

            this.setState({
                hasSites: res[0].list && res[0].list.length,
                hasNoActiveForPerm: this.props.item && !this.perm_levels.find(p => this.props.item._permission === p) && (!res[1].list || !res[1].list.length),
                loaded: true
            });
        })

    }

    async deleteTariff() {
        await this.props.item.delete();
        this.setState({showToast: 'Tariff ' + this.props.item.name + ' Deleted'})
        this.closeModal();
    }

    async saveSites() {


        let siteIds = this.state.newSitesList;

        if (!siteIds) siteIds = [];
        let id = this.props.item ? this.props.item.id : this.state.createdTariffId

        let tariff;
        try {
            tariff = await GridDuck.getTariff({id: id})
        } catch (e) {

        }
        if (tariff) {

            try {
                await tariff.set({siteIds: siteIds});
            } catch (e) {

            }
        }

        return Promise.resolve();

    }

    async saveChanges() {

        let res, tariff = {
            name: this.state.name,
            currency: this.state.currency,
            rates: this.state.rates.map((r) => {
                return {
                    startHour: r.startHour,
                    startMinute: r.startMinute,
                    endHour: r.endHour,
                    endMinute: r.endMinute,
                    rate: parseFloat(r.rate)
                }
            }),
            applyContractRange: this.state.applyContractRange,
            applyBillingCycle: this.state.applyBillingCycle,
            billingCycleType: this.state.billingCycleType,
            billingCycleStartDay: this.state.billingCycleStartDay,
            contractStart: this.state.contractStart,
            contractEnd: this.state.contractEnd,
            utilityType: this.state.utilityType,
            standingCharge: this.state.standingCharge
        };

        let self = this;
        let item = self.props.item;
        if (item) {
            res = await item.set(tariff);
            this.setState({showToast: 'Tariff ' + tariff.name + ' Updated', formUpdated: false});
        } else {
            res = await GridDuck.createTariff(tariff);

            this.setState({showToast: 'Tariff ' + tariff.name + ' Created', createdTariffId: res.id});
        }
        return Promise.resolve(res)
    }

    async saveDetails() {

        let tariffErrors = this.checkErrors(true);

        if (Object.keys(tariffErrors).length > 0) return Promise.reject();
        await this.saveChanges();

        if (this.state.sitesUpdated) await this.saveSites();

        if (this.props.onSave) {

            this.props.onSave(this.state.showToast)
        }

        if (!this.props.item) {
            this.closeModal();
        }

        return Promise.resolve();
    }

    onTabClick(ev, tab) {
        this.tabs.forEach(function (tabArr) {
            tabArr.forEach(function (t) {
                t.selected = (tab.id === t.id);
            })
        })
        this.setState(this.state);
    }

    closeModal() {
        this.modalClosed = true;
        this.props.onClose();
    }

    sitesChanged(a, b, itemsToAddRemove) {
        let startingIds = this.props.item ? this.props.item.siteIds : [];
        let newSitesList = startingIds.filter(itemId => !itemsToAddRemove.itemsToRemove.find(i => i.id === itemId)).concat(itemsToAddRemove.itemsToAdd.map(i => i.id));
        this.setState({newSitesList: newSitesList, formUpdated: true, sitesUpdated: true})
    }


    async getAvailableList(params) {
        if (!params.filters) params.filters = [];
        params.filters = params.filters.concat([{field: '_permission', value: this.perm_levels}]);
        let sites = await GridDuck.getSites(params);
        if (this.props.item) {
            sites.list = sites.list.filter(a => !this.props.item.siteIds.includes(a.id));
            sites.total = sites.total -= this.props.item.siteIds.length;
        }
        return Promise.resolve(sites);
    }

    async getActiveList(params) {
        let self = this

        if (!this.props.item || !this.props.item.id) return Promise.resolve({list: [], total: 0})

        // if (!this.state.newSitesList.length) {
        params.filters = [
            {
                field: 'tariffIds',
                value: [this.props.item.id]
            },
            {field: '_permission', value: this.perm_levels}
        ]
        return GridDuck.getSites(params);
        // } else return Promise.resolve({list: self.state.newSitesList, total: self.state.newSitesList.length});
    }

    moveToTab() {
        let errors = this.checkErrors(true);
        if (errors) errors = Object.keys(errors).length;
        if (errors) return Promise.reject();
        this.onTabClick(null, {id: 2});
    }

    convertTimesToWholeNumbers(rate) {
        return {
            start: parseInt(rate.startHour) + (parseInt(rate.startMinute) ? 0.5 : 0),
            end: parseInt(rate.endHour) + (parseInt(rate.endMinute) ? 0.5 : 0)
        }
    }

    checkErrors(saving) {
        let self = this;
        this.errors = {};
        if (!this.state.name) this.errors['name'] = true;
        if (!this.state.currency) this.errors['currency'] = true;
        if (!this.state.utilityType) this.errors['utilityType'] = true;
        let _rates = this.state.rates;
        let _conflicts = {}
        _rates.forEach((r, index) => {
            //
            if (!parseInt(r.rate)) this.errors['rate' + r.id] = true
            let conflicts = _rates.filter((r2) => {
                let r2_whole = self.convertTimesToWholeNumbers(r2),
                    r_whole = self.convertTimesToWholeNumbers(r);
                let conflict = false;
                if ((r_whole.start > r2_whole.start && r_whole.start < r2_whole.end) || (r_whole.end > r2_whole.start && r_whole.end < r2_whole.end) || (r_whole.start === r_whole.end) || (r2_whole.end === r2_whole.start)) {
                    conflict = true
                }
                return conflict;
            });
            conflicts.map((c, i) => {
                return c.index = i
            })
            let filteredConflicts = conflicts.filter((c) => {
                return c.index !== index
            })
            //
            if (filteredConflicts.length) _conflicts[index] = filteredConflicts;
        })
        let errorMessages;
        if (Object.keys(_conflicts).length > 0) {
            errorMessages = []
            for (const [key, value] of Object.entries(_conflicts)) {
                let error = 'Conflict between Rate ' + (value[0].index + 1) + ' and Rate ' + (parseInt(key) + 1)
                errorMessages.push(error)
            }

            this.errors['conflict'] = true;
        }
        if (saving) this.setState({triedToSave: true, errorMessages: errorMessages})
        return this.errors;
    }

    render() {
        let footer;

        let tariffErrors = this.checkErrors();
        if (tariffErrors) tariffErrors = Object.keys(tariffErrors).length;
        this.tabs[0][1].disabled = tariffErrors && !this.props.item;

        if (this.state.formUpdated && this.props.item) footer =
            <Button progressRes
                    additionalclasses={'sm'}
                    label={'Save Changes'}
                    color={'gd-brand'}
                    onClick={this.saveDetails}/>

        if (this.tabs[0][0] && this.tabs[0][0].selected && !this.props.item) footer =
            <Button additionalclasses={'sm'}
                    label={'Next'}
                    color={'gd-brand'}
                    onClick={this.moveToTab}/>

        if (this.tabs[0][1] && this.tabs[0][1].selected && !this.props.item) footer =
            <Button progressRes additionalclasses={'sm'}
                    label={'Create Tariff'} color={'gd-green'}
                    onClick={this.saveDetails}/>

        if (this.tabs[0][2] && this.tabs[0][2].selected) footer =
            <Button progressRes disabled={this.state.deleteConfirmation !== 'DELETE'} additionalclasses={'md'}
                    label={'Permanently Delete'} color={'gd-red'}
                    onClick={this.deleteTariff}/>
        let title = this.props.item ? this.props.item.name + ' Tariff' : 'Create Tariff'
        if (this.props.item && !this.aperm_levels.find(p => this.props.item._permission === p)) {
            title = this.props.item.name + ' Tariff';
        }

        let in_view = !!(this.props.item && !this.aperm_levels.find(p => this.props.item._permission === p) || this.props.orgPerm === 'view');



        return (
            <GdModal
                title={title}
                open={this.props.open}
                contentLabel={'Tariff'}
                footer={footer}
                wide={this.tabs && this.tabs[0][1].selected}
                onClose={this.closeModal}>
                {this.tabs ? <Tabs tabData={this.tabs}/> : null}
                <CardBody additionalclasses={(this.tabs[0][1] && this.tabs[0][1].selected ? ' no-padding' : '')}>
                    {this.tabs[0][0] && this.tabs[0][0].selected ?
                        <TariffForm
                            disabled={in_view}
                            formData={{
                                name: this.state.name,
                                currency: this.state.currency,
                                utilityType: this.state.utilityType,
                                standingCharge: this.state.standingCharge,
                                rates: this.state.rates,
                                applyContractRange: this.state.applyContractRange,
                                contractStart: this.state.contractStart,
                                contractEnd: this.state.contractEnd,
                                applyBillingCycle: this.state.applyBillingCycle,
                                billingCycleType: this.state.billingCycleType,
                                billingCycleStartDay: this.state.billingCycleStartDay
                            }}
                            triedToSave={this.state.triedToSave}
                            errors={this.errors || {}}
                            funcs={{
                                convertTimesToWholeNumbers: this.convertTimesToWholeNumbers
                            }}
                            onBillingCycleTypeChange={(val) => this.setState({billingCycleType: val, billingCycleStartDay: 1, formUpdated: true})}
                            onBillingCycleStartDayChange={(val) => this.setState({billingCycleStartDay: val, formUpdated: true})}
                            onApplyContractRangeChange={(val) => this.setState({applyContractRange: val, formUpdated: true})}
                            onApplyBillingCycleChange={(val) => this.setState({applyBillingCycle: val, formUpdated: true})}
                            onContractRangeChange={(dates) => this.setState({contractStart: dates.start, contractEnd: dates.end, formUpdated: true})}
                            errorMessages={this.state.errorMessages}
                            onRatesChange={(rates) => this.setState({rates: rates, formUpdated: true})}
                            onCurrencyChange={(currency) => {
                                this.setState({currency: currency, formUpdated: true})
                            }}
                            onNameChange={(name) => this.setState({name: name, formUpdated: true})}
                            onUtilityTypeChange={(utilityType) => this.setState({
                                utilityType: utilityType,
                                formUpdated: true
                            })}
                            onStandingChargeChange={(standingCharge) => this.setState({
                                standingCharge: standingCharge,
                                formUpdated: true
                            })}
                            ref={this.tariffFormRef}>
                            {this.props}
                        </TariffForm>
                        : ''}
                    {this.tabs[0][1] && this.tabs[0][1].selected ?
                        <div style={{height: '100%'}}>
                            {this.state.loaded ? <div className={'row'} style={{height: '100%'}}>
                                {this.state.hasSites && !this.state.hasNoActiveForPerm ? <EditableList
                                    isEditing={!this.props.item || this.props.item._permission !== 'view'}
                                    disabled={in_view}
                                    columns={[
                                        {
                                            component: StandardListCell,
                                            bold: true,
                                            title: 'Name',
                                            field: 'name',
                                            sortable: true,
                                            defaultSort: 'asc'
                                        },
                                        {
                                            component: StandardListCell,
                                            title: 'Access level',
                                            field: '_permission',
                                            maxWidth: 'none'
                                        },
                                    ]}
                                    key={1}
                                    onChange={this.sitesChanged}
                                    noCancel={true}
                                    noSave
                                    getActiveList={this.getActiveList}
                                    getAvailableList={this.getAvailableList}
                                /> : null}
                                {!this.state.hasSites && !this.state.hasNoActiveForPerm ?
                                    <div>You have no sites of which you have either edit or admin access</div> : null}
                                {this.state.hasNoActiveForPerm ?
                                    <div>This tariff hasn't been added to any sites</div> : null}
                            </div> : <GenericLoader/>}
                        </div>: ''}
                    {this.tabs[0][2] && this.tabs[0][2].selected ? <div>
                        <div className={'row'}>
                            <Input required error={this.errors['delete'] && this.state.triedToDelete} top='true'
                                   onChange={(e) => this.setState({deleteConfirmation: e.target.value})}
                                   placeholder={'Type DELETE here'}
                                   name={'delete'} value={this.state.deleteConfirmation}
                                   label={'Enter DELETE (case sensitive) in the input and then click the button bellow'}/>
                        </div>
                    </div> : ''}
                </CardBody>
            </GdModal>
        )
    }
}

export default TariffModal;
